// extracted by mini-css-extract-plugin
module.exports = {"root":"az_c5b","certonaPartCard":"az_d5b","svgForOos":"az_e5b"};